import { render, staticRenderFns } from "./addNeditDialog.vue?vue&type=template&id=130170d8&scoped=true&"
import script from "./addNeditDialog.vue?vue&type=script&lang=js&"
export * from "./addNeditDialog.vue?vue&type=script&lang=js&"
import style0 from "./addNeditDialog.vue?vue&type=style&index=0&id=130170d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130170d8",
  null
  
)

export default component.exports